import { type Meta } from '../types/docs';

const META: Meta = {
  description: 'Called when user clicks "Download Transcript" button',
  name: 'clicked_download_transcript_button',
  params: [
    {
      description: 'The ID of clip',
      name: 'clip_id',
      required: true,
      type: 'string',
    },
  ],
};

export default META;
